// -------------------- Material Ui Table Components --------------
export {Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination} from '@material-ui/core';
// -------------------- Material Ui Table Components --------------


// ----------------------------- COMMON ---------------------------------------
export { API, axios, createData, Field, Form, Formik, FieldArray, handleOtherResponseCode, Image, imageSize,
         Link, motion, NextServerCookies, PAGE_ANIMATION_OPTIONS, REDIRECT, Sidebar, SUCCESS_REPONSE_CODE, toastr, 
         useEffect, useRouter, useState, useRef, useSWR, useTranslation, UNAUTHORIZED_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE,
         Yup, ErrorPages, ClientDashboard, SidebarAction, getSession, CustomToastrAction, Tooltip} from '@/imports-files/common/common';
// ----------------------------- COMMON ---------------------------------------


// ----------------- Constants ---------------------
export { ROWS } from '@/constants/pages/clients/manage-integration';
// ----------------- Constants ---------------------


export { default as InfoIcon } from 'public/icons/info.svg';


// -----------------------------  CUSTOM COMPONENTS -----------------------------
export {default as Button} from '@/components/button';
export {SendRequest} from '@/services/common/send-request';
export {MyIntegration} from '@/services/pages/clients/activities/my-integrations';
export {createIntegrationData, getIntegrationsStatus, getButtonClass, connectDisconnectIntegration, getMyIntegrationData} from '@/actions/pages/clients/settings/my-integrations';
// export {getIntegrationsStatus, turnOnOffAccessibility} from '@/actions/pages/clients/activities/client-integrations'
export {SkipModal} from '@/components/skip-modal';
export {IntegrationPopup} from '@/components/integration-popup';
export { default as QuickAdd } from "@/components/quick-add";
// -----------------------------  CUSTOM COMPONENTS -----------------------------


// -----------------------------  ACTIONS -----------------------------
export {ActivitiesAction} from '@/actions/pages/clients/activities/index';
// -----------------------------  ACTIONS  -----------------------------

// ---------------------------- Stylesheet -------------------------------------

export {default as PageStyle} from '@/styles/pages/admins/dashboard/clients/new/_index.module.scss';
export {default as Styles} from '@/styles/pages/admins/dashboard/clients/integration/_index.module.scss';
export {default as ButtonStyle} from '@/styles/components/button/_index.module.scss';
// ----------------------------- Stylesheet ------------------------------------
